module.exports = __webpack_public_path__ + "img/camera-fill.0bc032cb.svg";